import React, { useState, useEffect, useRef } from "react";
import {Accordion, AccordionDetails, AccordionSummary, TextField, FormControl, FormLabel, FormGroup, Checkbox, FormControlLabel} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import config from '../../../hoa-config';
import MultilineRegulationsTextArea from '../../../Container/multiline-regulations-text-area'
import VehiclesDropdown from "./common/vehiclesDropdown";
import useFieldDisabled from "../../../hooks/useFieldDisabled";
import VehiclesDropdownAutoSelect from "./common/VehicleDropdownAutoSelect";
import EditCancelConfirmationModal from "../../../shared-components/edit-cancel-confirmation";
interface HoaParkingFormProps {
    handleChange : any;
    values: any;
}

export default function HoaParkingForm(props: HoaParkingFormProps) {
    const {handleChange, values} = props;
    const [vehicleOptions, setVehicleOptions] = useState(config.prohibitedVehicle);
    const { isParkingFiledDisabled } = useFieldDisabled();

    const stateList : any = {
        isStateParkingNotAllowed: false,
        notAllowedCarTypes: [],
        priorApprovalNeededForStreetParking: true,
        timeLimitForStreetParking : '',
        speedLimitInsideHoa: '',
        numberOfCarsAllowedOnLot : '',
        garageCapacity : '',
        drivewayParkingRestrictedOptions : [],
        unlicensedVehicleRestrictedOptions : [],
        prohibitedVehicles : '',
        regulationsOfnumberOfCarsAllowed: '',
        regulationsOfgarageCapacity: '',
        regulationsOfRepairMaintenanceOfCars: '',
        regulationsOfGarageSales: '',
        typesOfCommercialVehicle: '',
        regulationsOfVechicleProduceNoiseSmoke: '',
        regulationsOfProhibitedVehicle: '',

    }
    const [listToggle, setListToggle] = useState(false);
    const [listToggle2, setListToggle2] = useState(false);
    const [open, setOpen] = useState<any>({});
    const [searchText, setSearchText] = useState('');
    const [state, setState] = useState(stateList);
    const [expanded1, setExpanded1] = useState(false);
    const [expanded2, setExpanded2] = useState(false);
    const [expanded3, setExpanded3] = useState(false);
    const [prohibitedVehicleList, setProhibitedVehicleList] = useState([]);
    const [isWaring, setIsWarning] = useState(false);
    const [fieldInfo, setFieldInfo] = useState({
        field: '',
        key: '',
    });

    const removedAutoSuggestedVehiclesRef = useRef<Set<string>>(new Set());
    const hasParsedRegulationTextRef = useRef(false);

    useEffect(() => {
        if (values) {
            let tempState = { ...state };
            Object.keys(tempState).map((key) => {
                tempState[key] = values[key] || (Array.isArray(tempState[key]) ? [] : typeof tempState[key] === 'object' ? {} : '');
            })
            setState(tempState);
        }
    }, [values])

    useEffect(() => {
        if(state.prohibitedVehicles != ""){
            // let data = state.prohibitedVehicles?.split(', ').filter((vehicle: any) => {
            //     for(const key of config.prohibitedVehicle){
            //         for(const item of key.items){
            //             if(item.key.toLowerCase() == vehicle.toLowerCase()){
            //                 return vehicle;
            //             }
            //         }
            //     }
            // })
            let data = [];
            if (state.prohibitedVehicles.includes(",")) {
                let values = state.prohibitedVehicles.replace(/\n/g, "").split(",");
                data = values
            } else {
                let values = state.prohibitedVehicles.replace(/\n/g, ", ");
                data = values.split(',');
            }
            setProhibitedVehicleList(data)
        }
    },[state.prohibitedVehicles])

    useEffect(() => {
        if(searchText){
            let data = vehicleOptions.filter((vehicle: any, index: any) => {
                return vehicle.items.some((item: any) => {
                    if(item.key.toLowerCase().includes(searchText.toLowerCase())){
                        return item;
                    }
                });
              });
              if(data){
                  handleClick(data[0]?.key)
                  setVehicleOptions(data)
              }
        }else{
            setVehicleOptions(config.prohibitedVehicle)
        }
    },[searchText])

    const handleVehicleChange = (key: any) => {
        const trimmedKey = key?.trim();
        if (!trimmedKey) return; 
        const isDuplicate = prohibitedVehicleList.some(
        (item) => item.trim().toLowerCase() === trimmedKey.toLowerCase()
        );
        if (isDuplicate) return;
        const updatedList = [...prohibitedVehicleList, trimmedKey];
        const tempState: any = { ...state, prohibitedVehicles: concatVehicles(updatedList) };
        setProhibitedVehicleList(updatedList);
        setState(tempState);
        handleChange(tempState, 'parking');
        setSearchText("");
        setListToggle(!listToggle);
    };

    const removeProhibitedVehicle = (vehicle: string) => {
        const tempState: any = { ...state };
        const vehicles = prohibitedVehicleList.filter((item: string) => item !== vehicle);
        setProhibitedVehicleList(vehicles);
        tempState.prohibitedVehicles = concatVehicles(vehicles);
        setState(tempState);
        handleChange(tempState, 'parking');
        removedAutoSuggestedVehiclesRef.current.add(vehicle);
    };

    const concatVehicles = (vehicles: string[]) =>{
        let vehiclesString = '';
        vehicles.map((vehicle: string, index: number)=>{
            vehiclesString+=vehicle;
            if(index < vehicles.length -1){
                vehiclesString += ", ";
            }
        })
        return vehiclesString;
    }

    const handleCurrentChange = (value: any, key: string, checkBoxSelectedKey:string = '') => {
        let tempState: any = { ...state };
        tempState[key] = value;
        if(key == 'isStateParkingNotAllowed' && !value) {
            tempState['notAllowedCarTypes'] = []
        }
        if(checkBoxSelectedKey && config.violationRegulations[checkBoxSelectedKey]) {
            tempState[config.violationRegulations[checkBoxSelectedKey]] = '';
        }
        setState(tempState);
        handleChange(tempState, 'parking');
    }

    const handleCheckBoxGroup = (checked: boolean, key: string, stateName : string, regulation?: string) => {
        if (!checked && regulation) {
            setFieldInfo({
                field: stateName,
                key: key,
            });
            setIsWarning(!isWaring);

        } else {
            let tempValue = state[stateName];
            if(checked && !tempValue.includes(key)){
                tempValue.push(key);
            } else if(!checked && tempValue.includes(key)){
                tempValue = tempValue.filter((value: any) => {return value !== key})
            }
            handleCurrentChange(tempValue, stateName, key);
        }
    }

    const unCheckWarningYesClick = () => {
        let tempValue = state[fieldInfo.field];
        if(tempValue.includes(fieldInfo.key)){
            tempValue = tempValue.filter((value: any) => {return value !== fieldInfo.key})
        }
        handleCurrentChange(tempValue, fieldInfo.field, fieldInfo.key);
        setIsWarning(false);
    }

    const Wheel =(e: any) => {
        e.target.blur();
    }

    const handleClick =(key: any) => {
        setOpen({ [key]: !open[key] });
      };

    const handleListToggle =()=>{
        setListToggle(!listToggle)
    }
    const handleNotAllowedCarListToggle =()=>{
        setListToggle2(!listToggle2)
    }

    const handleNoAllowedCarTypes = (vehicle: string) => {
        const tempState = {...state};
        if(!tempState.notAllowedCarTypes.includes(vehicle)) {
            tempState.notAllowedCarTypes.push(vehicle);
            setState(tempState);
            handleChange(tempState, 'parking');
            setSearchText("");
        }
        setListToggle2(!listToggle2)
        return;
    }

    const removeNoAllowedCarTypes = (vehicle: string) => {
    const tempState = { ...state };
    tempState.notAllowedCarTypes = tempState.notAllowedCarTypes.filter(
        (v: string) => v !== vehicle
    );
    setState(tempState);
    handleChange(tempState, 'parking');
};


    const handleMultipleVehicleChanges = (keys: string[]) => {
        const existingNormalized = prohibitedVehicleList.map(item => item.trim().toLowerCase());
        const newVehicles = [...prohibitedVehicleList];
        let updated = false;
        keys.forEach(key => {
            const trimmedKey = key.trim();
            const normalizedKey = trimmedKey.toLowerCase();
        if (!existingNormalized.includes(normalizedKey)) {
            newVehicles.push(trimmedKey);
            existingNormalized.push(normalizedKey);
            updated = true;
        }
        });
        if (updated) {
            const tempState: any = {
                ...state,
                prohibitedVehicles: concatVehicles(newVehicles),
            };
            setProhibitedVehicleList(newVehicles);
            setState(tempState);
            handleChange(tempState, 'parking');
        }
    };

    return (
        <>
            <Accordion
            style={{background: expanded1 ? "#EFF4FC" : ''}}
                onChange={(event, expanded)=>{
                    setExpanded1(expanded)
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    Street Parking
                </AccordionSummary>
                <AccordionDetails style={{background:"#FAFAFA"}}>
                <div style={{width: '100%', display:"flex", flexDirection:"column"}}>
                    <FormControl style={{ margin:"12px 0px",  }} component="fieldset" variant="standard" >
                    <FormLabel component="legend">Please select the options which are mandatory to perform.</FormLabel>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                <Checkbox checked={state.isStateParkingNotAllowed} 
                                    onChange={(event) => handleCurrentChange(event.target.checked, 'isStateParkingNotAllowed')} 
                                    disabled={isParkingFiledDisabled("isStateParkingNotAllowed") || isParkingFiledDisabled("notAllowedCarTypes")}    
                                />
                                }
                                label="Street parking is not allowed"
                            />
                        </FormGroup>
                    </FormControl>
                    {
                    state.isStateParkingNotAllowed && 
                    <VehiclesDropdown 
                        label='Type of cars not allowed'
                        listToggle={listToggle2}
                        handleListToggle={handleNotAllowedCarListToggle}
                        setSearchText={setSearchText}
                        open={open}
                        vehicleOptions={vehicleOptions}
                        handleClick={handleClick}
                        handleVehicleChange={handleNoAllowedCarTypes}
                        prohibitedVehicleList={state.notAllowedCarTypes}
                        removeVehicle={removeNoAllowedCarTypes}
                        disabled={isParkingFiledDisabled("notAllowedCarTypes")}
                     />
                    }
                </div>
                <div style={{width: '100%', display:"flex", flexDirection:"column"}}>
                    <FormControl style={{ margin:"12px 0px",  }} component="fieldset" variant="standard" >
                        <FormGroup>
                            <FormControlLabel
                                control={
                                <Checkbox 
                                    checked={state.priorApprovalNeededForStreetParking} 
                                    onChange={(event) => handleCurrentChange(event.target.checked, 'priorApprovalNeededForStreetParking')} 
                                    disabled={isParkingFiledDisabled("priorApprovalNeededForStreetParking")}  
                                />
                                }
                                label="Prior Approval Needed for Street Parking"
                            />
                        </FormGroup>
                    </FormControl>
                    <TextField 
                        style={{ width: "35%", marginRight:"10px" }} 
                        variant="standard" 
                        label="Time Limit for Street Parking" 
                        value={state.timeLimitForStreetParking}
                        onChange={(e)=>{handleCurrentChange(e.target.value, "timeLimitForStreetParking")}} 
                        InputLabelProps={{style:{fontSize:"14px", transform:"translateY(7px)"}}}
                        disabled={isParkingFiledDisabled("timeLimitForStreetParking")}  
                        InputProps={{
                            style:{ padding:"7px 0px"},
                        }}/>
                    <div style={{margin:"12px 0px", fontSize:"14px"}}>Street Parking - Speed limit inside HOA.</div>
                     <TextField 
                        style={{ width: "75%", marginBottom:"24px"}} 
                        variant="outlined" 
                        value={state?.speedLimitInsideHoa}
                        onChange={(e) => { handleCurrentChange(e.target.value, "speedLimitInsideHoa") }} 
                        label="Write here..." multiline
                        InputLabelProps={{ style: { fontSize: "14px", margin: "5px" } }} 
                        InputProps={{ style: { minHeight:"106px" } }}
                        disabled={isParkingFiledDisabled("speedLimitInsideHoa")}  
                    />
                </div>
                </AccordionDetails>
            </Accordion>

            <Accordion
            style={{background: expanded2 ? "#EFF4FC" : ''}}
                onChange={(event, expanded)=>{
                    setExpanded2(expanded)
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    Driveway Parking
                </AccordionSummary>
                <AccordionDetails style={{background:"#FAFAFA", flexDirection:"column"}}>
                <div style={{width: '100%', display:"flex", flexDirection:"column"}}>
                    <span style={{ fontSize: '1rem', marginBottom:'5px' }}>Car Details</span>
                    <div style={{ display: "flex", flexDirection: "column", marginBottom: "12px"}}>
                        <TextField 
                            style={{ width: '70%', marginRight: "20px", height: '64px' }} 
                            variant="standard" 
                            label="Number of Cars Allowed on Lot" 
                            value={state.numberOfCarsAllowedOnLot} 
                            type='number'
                            onChange={(e) => { handleCurrentChange(e.target.value, "numberOfCarsAllowedOnLot") }} 
                            onWheel={e => Wheel(e)} 
                            InputLabelProps={{ style: { fontSize: "14px" } }}
                            InputProps={{ style: { padding: "7px 0px" } }} 
                            disabled={isParkingFiledDisabled("numberOfCarsAllowedOnLot")}  
                        />
                        <MultilineRegulationsTextArea 
                            regulationType={'regulationsOfnumberOfCarsAllowed'}
                            value={state.regulationsOfnumberOfCarsAllowed}
                            handleCurrentChange={handleCurrentChange}
                            disabled={isParkingFiledDisabled("regulationsOfnumberOfCarsAllowed")}  
                        />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", marginBottom: "12px"}}>
                        <span style={{ fontSize: '1rem', marginBottom:'5px' }}>Garage Capacity</span>
                        <TextField 
                            style={{ width: '65%', marginRight: "20px"}} 
                            variant="standard" 
                            label="Garage Capacity" 
                            value={state.garageCapacity} 
                            type='text'
                            onChange={(e) => { handleCurrentChange(e.target.value, "garageCapacity") }} 
                            InputLabelProps={{ style: { fontSize: "14px" } }}
                            multiline 
                            InputProps={{ style: { padding: "7px 0px" } }}
                            disabled={isParkingFiledDisabled("garageCapacity")}  
                        />
                        <MultilineRegulationsTextArea 
                            regulationType={'regulationsOfgarageCapacity'}
                            value={state.regulationsOfgarageCapacity}
                            handleCurrentChange={handleCurrentChange}
                            disabled={isParkingFiledDisabled("regulationsOfgarageCapacity")}  
                        />
                    </div>
                    <FormControl style={{ margin:"12px 0px",  }} component="fieldset" variant="standard" >
                        <FormLabel component="legend">Please select the options which are restricted.</FormLabel>
                        <FormGroup>
                        <FormControlLabel
                            control={
                            <Checkbox 
                                checked={state.drivewayParkingRestrictedOptions.includes('Blocking Sidewalk')} 
                                onChange={(event) => handleCheckBoxGroup(event.target.checked, 'Blocking Sidewalk', 'drivewayParkingRestrictedOptions')}
                                disabled={isParkingFiledDisabled("drivewayParkingRestrictedOptions")}  
                            />
                            }
                            label="Blocking Sidewalk"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox 
                                checked={state.drivewayParkingRestrictedOptions.includes('Open Garage Doors')} 
                                onChange={(event) => handleCheckBoxGroup(event.target.checked, 'Open Garage Doors', 'drivewayParkingRestrictedOptions')} 
                                disabled={isParkingFiledDisabled("drivewayParkingRestrictedOptions")} 
                            />
                            }
                            label="Open Garage Doors"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.drivewayParkingRestrictedOptions.includes('Repair and Maintenance of Cars')} 
                                    onChange={(event) => handleCheckBoxGroup(event.target.checked, 'Repair and Maintenance of Cars', 'drivewayParkingRestrictedOptions', state.regulationsOfRepairMaintenanceOfCars)} 
                                    disabled={isParkingFiledDisabled("drivewayParkingRestrictedOptions") || isParkingFiledDisabled("regulationsOfRepairMaintenanceOfCars")} 
                                />
                            }
                            label="Repair and Maintenance of Cars"
                        />
                        {
                                state.drivewayParkingRestrictedOptions.includes('Repair and Maintenance of Cars') &&
                                <MultilineRegulationsTextArea 
                                    regulationType={'regulationsOfRepairMaintenanceOfCars'}
                                    value={state.regulationsOfRepairMaintenanceOfCars}
                                    handleCurrentChange={handleCurrentChange}
                                    disabled={isParkingFiledDisabled("regulationsOfRepairMaintenanceOfCars")} 
                                />
                        }
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.drivewayParkingRestrictedOptions.includes('Garage Sales')} 
                                    onChange={(event) => handleCheckBoxGroup(event.target.checked, 'Garage Sales', 'drivewayParkingRestrictedOptions', state.regulationsOfGarageSales)} 
                                    disabled={isParkingFiledDisabled("drivewayParkingRestrictedOptions") || isParkingFiledDisabled("regulationsOfGarageSales")} 
                                />
                            }
                            label="Garage Sales"
                        />
                        {
                                state.drivewayParkingRestrictedOptions.includes('Garage Sales') &&
                                <MultilineRegulationsTextArea 
                                    regulationType={'regulationsOfGarageSales'}
                                    value={state.regulationsOfGarageSales}
                                    handleCurrentChange={handleCurrentChange}
                                    disabled={isParkingFiledDisabled("regulationsOfGarageSales")} 
                                />
                        }
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.drivewayParkingRestrictedOptions.includes('Parking on common areas')} 
                                    onChange={(event) => handleCheckBoxGroup(event.target.checked, 'Parking on common areas', 'drivewayParkingRestrictedOptions')} 
                                    disabled={isParkingFiledDisabled("drivewayParkingRestrictedOptions")}
                                />
                            }
                            label="Parking on common areas"
                        />
                        </FormGroup>
                    </FormControl>
                </div>
                </AccordionDetails>
            </Accordion>

            <Accordion
            style={{background: expanded3 ? "#EFF4FC" : ''}}
                onChange={(event, expanded)=>{
                    setExpanded3(expanded)
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    Unlicensed Vehicle
                </AccordionSummary>
                <AccordionDetails style={{background:"#FAFAFA"}}>
                <div style={{width: '100%', display:"flex", flexDirection:"column"}}>
                    <FormControl style={{ margin:"12px 0px",  }} component="fieldset" variant="standard" >
                        <FormLabel component="legend">Please select the options which are restricted.</FormLabel>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        checked={state.unlicensedVehicleRestrictedOptions.includes('Commercial Vehicles')} 
                                        onChange={(event) => handleCheckBoxGroup(event.target.checked, 'Commercial Vehicles', 'unlicensedVehicleRestrictedOptions', state.typesOfCommercialVehicle)}
                                        disabled={isParkingFiledDisabled("unlicensedVehicleRestrictedOptions") || isParkingFiledDisabled("typesOfCommercialVehicle")}
                                    />
                                }
                                label="Commercial Vehicles"
                            />
                            {
                                state.unlicensedVehicleRestrictedOptions.includes('Commercial Vehicles') &&
                                <MultilineRegulationsTextArea
                                    label='Types of Commercial Vehicles' 
                                    regulationType={'typesOfCommercialVehicle'}
                                    value={state.typesOfCommercialVehicle}
                                    handleCurrentChange={handleCurrentChange}
                                    disabled={isParkingFiledDisabled("typesOfCommercialVehicle")}
                                />
                            }
                        </FormGroup>
                    </FormControl>
                    <VehiclesDropdownAutoSelect
                        label='Prohibited Vehicles'
                        listToggle={listToggle}
                        handleListToggle={handleListToggle}
                        setSearchText={setSearchText}
                        open={open}
                        vehicleOptions={vehicleOptions}
                        handleClick={handleClick}
                        handleVehicleChange={handleVehicleChange}
                        prohibitedVehicleList={prohibitedVehicleList}
                        removeProhibitedVehicle={removeProhibitedVehicle}
                        disabled={isParkingFiledDisabled("prohibitedVehicles")}
                        regulationText={state.regulationsOfProhibitedVehicle}
                        handleMultipleVehicleChanges={handleMultipleVehicleChanges}
                        removedAutoSuggestedVehiclesRef={removedAutoSuggestedVehiclesRef}
                        hasParsedRegulationTextRef={hasParsedRegulationTextRef}
                    />
                    <MultilineRegulationsTextArea 
                        regulationType={'regulationsOfProhibitedVehicle'}
                        value={state.regulationsOfProhibitedVehicle}
                        handleCurrentChange={handleCurrentChange}
                        disabled={isParkingFiledDisabled("regulationsOfProhibitedVehicle")}
                    />
                </div>
                </AccordionDetails>
            </Accordion>

            <EditCancelConfirmationModal 
                label="Are you sure you want to deselect? Regulation texts will be discarded if you confirm."
                isCancelClicked={isWaring}
                setIsCancelClicked={setIsWarning}
                onCancelYesClick={unCheckWarningYesClick}
            />
        </>
    )
}